module.exports = __webpack_public_path__ + "static/img/polacre.abf9226.png";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/polacre.png
// module id = Qs5k
// module chunks = 1